<div class="container-fluid">
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="card" style="margin: 2%">
        <div class="card-body">
          <h4 class="text-center card-title">
            <i class="fa fa-file-text-o"></i><strong>&nbsp;EPF Loan Requests ({{ loanRequestList.length + sharedLoanRequestList.length }})</strong>
          </h4>
          <h6 class="text-center text-secondary card-subtitle mb-2"><strong>Please review and reply</strong></h6>
          <div class="row">
            <div class="col-3">
              <mat-form-field>
                <mat-label>Ticket No</mat-label>
                <input matInput [(ngModel)]="searchText" (keyup)="filterTickets()" (keypress)="sharedService.isNumberKeyAllowNegative($event)" placeholder="Enter searching criteria" style="user-select: all" />
              </mat-form-field>
            </div>
            <!-- <div class="col-4">
            <button class="btn" (click)="clickPaste()"
              [ngClass]="{'btn-primary':clipboardCompareMessage==undefined || clipboardCompareMessage=='' ,'btn-warning': clipboardCompareMessage!=undefined && clipboardCompareMessage!='' }"
              #tooltip="matTooltip" [matTooltip]="clipboardCompareMessage" matTooltipPosition="above"
              matTooltipHideDelay="100" matTooltipClass="tooltip-black"><i
            class="fas fa-paste"></i></button>
          </div> -->
            <div class="col-3">
              <mat-form-field>
                <mat-label>Ticket Message</mat-label>
                <input matInput [(ngModel)]="clipboardCompareMessage" placeholder="Paste Ticket Message" (ngModelChange)="filterAndCompareMessage()" rows="1" style="user-select: all; white-space: pre" />
              </mat-form-field>
            </div>
            <div class="col-12">
              @if (sharedService.isAdmin()) {
                <div class="form-check form-switch fs-5 fw-bold d-inline-flex">
                  <input class="form-check-input" type="checkbox" id="isFirstPriority" name="isFirstPriority" [(ngModel)]="isFirstPriority" (change)="filterTickets()" />
                  <label class="form-check-label ms-2" for="isFirstPriority"> My branches Only</label>
                </div>
              }

              <div class="form-check form-switch fs-5 fw-bold d-inline-flex ms-2">
                <input class="form-check-input" type="checkbox" id="isClashedTickets" name="isClashedTickets" [(ngModel)]="isClashedTickets" (change)="filterTickets()" />
                <label class="form-check-label ms-2" for="isClashedTickets">Clashed</label>
              </div>
            </div>
          </div>
          @if (loanRequestList != undefined) {
            @for (request of loanRequestList; track request) {
              <div class="p-1 m-1">
                <app-all-loan-request-card [request]="request" [adminAccess]="companyAccess[request.CompanyId]" [disallowProcess]="disallowedClashTicketIds.includes(request.ID)" [clashedTickets]="getClashedICTickets(request)"></app-all-loan-request-card>
              </div>
            }
          }

          @if (sharedLoanRequestList != undefined) {
            @for (group of sharedLoanRequestList; track group) {
              <div class="p-1 m-1">
                <app-shared-loan-request-card [loanGroupRequest]="group" [allAdminAccess]="companyAccess" [disallowProcess]="checkDisallowProcessGroup(group)" [clashedTickets]="getClashedICTickets(group.requestList[0])"></app-shared-loan-request-card>
              </div>
            }
          }
        </div>
      </div>

      @if (wholeApprovedLoanRequestList.length > 0) {
        <div class="card" style="margin: 2%">
          <div class="card-body">
            <h4 class="text-center card-title">
              <i class="fa fa-file-text-o"></i><strong>&nbsp;Approved Ticket ({{ approvedWithoutloanRequestList.length }})</strong>
            </h4>
            <h6 class="text-center text-secondary card-subtitle mb-2"><strong>These are all approved tickets but did not open loan. Please check on it.</strong></h6>
            <div class="row">
              <div class="col-12">
                <mat-form-field>
                  <mat-label>Ticket No</mat-label>
                  <input matInput [(ngModel)]="searchApprovedText" (keyup)="applyApprovedFilter()" (keypress)="sharedService.isNumberKeyAllowNegative($event)" placeholder="Enter searching criteria" />
                </mat-form-field>
              </div>
            </div>
            @if (approvedWithoutloanRequestList != undefined) {
              @for (request of approvedWithoutloanRequestList; track request) {
                <div class="p-1 m-1">
                  <app-all-loan-request-card [request]="request" [adminAccess]="companyAccess[request.CompanyId]"></app-all-loan-request-card>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
    <div class="col-12 col-lg-6">
      @if (img !== "" && sharedService.isAdmin()) {
        <div class="card" style="margin: 2%" (click)="goToTodayReceipts()">
          <div class="card-body d-flex gap-3">
            <div class="flex-grow-1 d-flex gap-3 align-items-center">
              @if (setDonePercentage == 100) {
                <img class="me-3" [src]="img" style="width: 120px" />
                <div class="flex-grow-1">
                  <h5 class="opacity-60 mb-2">No pending receipt now</h5>
                  <h4 class="fw-bold mb-1">All Done!</h4>
                  <h5 class="text-secondary mb-3">
                    You have checked <span class="h4 text-dark fw-bold">{{ setCountDone }}</span> receipt today!
                  </h5>
                  <div class="d-flex gap-2 align-items-center">
                    <div class="progress flex-grow-1" role="progressbar">
                      <div class="progress-bar progress-bar-striped progress-bar-animated bg-success overflow-visible" [style.width.%]="setDonePercentage">{{ setDonePercentage }}%</div>
                    </div>
                  </div>
                </div>
              } @else {
                @if (setCountToday == 0) {
                  <img src="../../assets/image/box.png" style="width: 120px" />
                  <div>
                    <h4 class="fw-bold">No receipt for today yet!</h4>
                    @if (prevSetDate !== undefined) {
                      <div class="d-flex gap-3">
                        <button class="btn btn-lg btn-primary" (click)="checkPreviousReceipt()">Check Previous Receipts</button>
                        <svg class="float-x" width="32" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 5L5 1M1 5L5 9M1 5H11.5M17 5H14.5" stroke="#1C274C" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </div>
                    }
                  </div>
                  @if (prevSetDate !== undefined) {
                    <img [src]="img" style="height: 150px" />
                  }
                } @else {
                  <img class="me-3" [src]="img" style="width: 120px" />
                  <div class="flex-grow-1">
                    <h5 class="fw-bold opacity-60 mb-3">Total receipt to check by today: {{ setCountToday }}</h5>
                    <div class="d-flex gap-2 align-items-end mb-2">
                      <h4 class="fw-bold mb-0">{{ setCountDone }} done!</h4>
                      <h6 class="opacity-70 mb-0">{{ setCountPending }} remaining</h6>
                    </div>
                    <div class="progress flex-grow-1" role="progressbar">
                      <div class="progress-bar progress-bar-striped progress-bar-animated bg-success overflow-visible" [style.width.%]="setDonePercentage">{{ setDonePercentage }}%</div>
                    </div>
                  </div>
                }
              }
            </div>
            @if (setCountTotalPending > 0) {
              <ng-template #popContent>
                You have a total of <b>{{ setCountTotalPending }}</b> receipts left to review!
              </ng-template>
              <div class="align-self-end">
                <img src="../../assets/image/danger.png" style="width: 48px" [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
              </div>
            }
          </div>
        </div>
      }
      <div class="card" style="margin: 2%; background-color: lightgray; cursor: pointer" (click)="goToSettlementInfoCheck()">
        <div class="card-body">
          <h5 class="fw-bold"><i class="fas fa-not-equal"></i> Check EPF Settlement</h5>
        </div>
      </div>

      <div class="card" style="margin: 2%; cursor: pointer" (click)="goToAccountAuthorizations()">
        <div class="card-body">
          <h5 class="fw-bold"><i class="fas fa-landmark"></i> Check Contact Authorization</h5>
        </div>
      </div>

      <div class="card" style="margin: 2%">
        <div class="card-body">
          <h4 class="text-center card-title">
            <i class="fa fa-file-text-o"></i><strong>&nbsp;Other Loan Requests ({{ normalLoanRequestList.length }})</strong>
          </h4>
          <h6 class="text-center text-secondary card-subtitle mb-2"><strong>Please review and reply</strong></h6>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-label>Name / IC Number</mat-label>
                <input matInput [(ngModel)]="searchNormalText" (keyup)="applySearchNormalFilter()" placeholder="Enter searching criteria" />
              </mat-form-field>
            </div>
          </div>
          @if (normalLoanRequestList != undefined) {
            @for (request of normalLoanRequestList; track request) {
              <div class="p-1 m-1">
                <app-all-loan-request-card [request]="request" [adminAccess]="companyAccess[request.CompanyId]"></app-all-loan-request-card>
              </div>
            }
          }
        </div>
      </div>

      @if (transactionRequestList != undefined && transactionRequestList.length > 0) {
        <div class="card" style="margin: 2%">
          <div class="card-body">
            <ng-container>
              <h4 class="text-center card-title">
                <strong><i class="fas fa-exclamation-triangle"></i> HQ Assigned Transaction</strong>
              </h4>
              <div class="row">
                @for (request of transactionRequestList; track request) {
                  <div class="col-12">
                    <app-assigned-transaction-card [transactionRequest]="request"></app-assigned-transaction-card>
                  </div>
                }
              </div>
            </ng-container>
          </div>
        </div>
      }
      <div class="card" style="margin: 2%">
        <div class="card-body">
          <h4 class="text-center card-title"><i class="fa fa-file-text-o"></i><strong>&nbsp;UsageReport</strong></h4>
          <h6 class="text-center text-secondary card-subtitle mb-2"><strong>Monitor usage by showing latest account date</strong></h6>
          <app-usage-report-card [usageList]="usageList"></app-usage-report-card>
        </div>
      </div>
    </div>
  </div>

  <!-- End of Add Customer Modal -->
  <div class="modal fade" id="addCustomer">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <app-add-customer></app-add-customer>
      </div>
    </div>
    <!-- End of Add Customer Modal -->
  </div>
</div>
